var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversationsBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Conversations_Outline_24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.2,
    height: 21.2,
    viewBox: "0 0 21.2 21.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1110",
    "data-name": "Rectangle 1110",
    width: 21.2,
    height: 21.2,
    fill: "#ffe4e4",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Conversations_Outline_24px-2",
    "data-name": "Conversations_Outline_24px",
    transform: "translate(0.883 0.883)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1107",
    "data-name": "Rectangle 1107",
    width: 19.433,
    height: 19.433,
    fill: "#787f88",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3231",
    "data-name": "Group 3231",
    transform: "translate(0.936 1.369)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1108",
    "data-name": "Rectangle 1108",
    width: 9.92,
    height: 1.325,
    rx: 0.662,
    transform: "translate(2.906 3.33)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1109",
    "data-name": "Rectangle 1109",
    width: 6.651,
    height: 1.325,
    rx: 0.662,
    transform: "translate(2.906 6.916)",
    fill: "#787f88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M19.117,13.68a1.876,1.876,0,0,1-1.9,1.855H5.849L2.06,19.245V4.4a1.876,1.876,0,0,1,1.9-1.855H17.227a1.876,1.876,0,0,1,1.9,1.855V9.829",
    transform: "translate(-2.06 -2.55)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 0.503,
    cy: 0.503,
    r: 0.503,
    transform: "translate(16.554 8.727)",
    fill: "#787f88"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationsBlackIcon);
export default __webpack_public_path__ + "static/media/conversations-black-icon.4a2d10a297fc5bb7b532135fe7116e16.svg";
export { ForwardRef as ReactComponent };